import {Link} from 'gatsby';
import * as React from 'react';
import {Trans, withTranslation, WithTranslation} from 'react-i18next';

import * as styles from './enroll.module.scss';

import type {PbpsPlan} from '@graphql-types';

interface QualificationWarningProps extends WithTranslation<'EnrollTemplate'> {
  pbp: {
    plan: Pick<PbpsPlan, 'ma_variant'>;
  };
}

const QualificationWarning: React.FC<QualificationWarningProps> = ({
  pbp,
  t,
}) => {
  switch (pbp.plan.ma_variant) {
    case 'CSNP':
      return (
        <p className={styles.warning}>
          <Trans i18nKey="qualificationWarning.CSNP" t={t}>
            Once you submit this application, we'll call to confirm that you
            have one of the{' '}
            <Link
              // @ts-ignore
              to={t('PlanTable:chronicConditionsEligibilityUrl')}>
              eligible chronic health conditions
            </Link>{' '}
            needed to qualify for this plan.
          </Trans>
        </p>
      );
    case 'DSNP':
      return (
        <p className={styles.warning}>
          <Trans i18nKey="qualificationWarning.DUAL" t={t}>
            You must{' '}
            <Link
              // @ts-ignore
              to={t('PlanTable:dualEligibilityUrl')}>
              qualify
            </Link>{' '}
            for both Medicare and Medicaid to enroll in this Dual-Eligible
            Special Needs Plan (D-SNP).
          </Trans>
        </p>
      );
    default:
      return <></>;
  }
};

export default withTranslation('EnrollTemplate')(QualificationWarning);
